
  class CountrySelector extends HTMLElement {
    connectedCallback() {
      this.selectEl =
        this.querySelector('select[data-country-select]') ||
        this.querySelector('#country-lang');
      this.nameEl = this.querySelector('.selected-country-name');

      if (this.selectEl) {
        // Full mode: select + span
        this.syncSelectedOption();
        this.updateName();
        this.onChange = (e) => {
          this.updateName();
          const url = e.target.value;
          if (url) window.location.href = url;
        };
        this.selectEl.addEventListener('change', this.onChange);
      } else if (this.nameEl) {
        // Display-only mode: span only
        this.setNameFromLocation();
      }
    }

    disconnectedCallback() {
      if (this.selectEl && this.onChange) {
        this.selectEl.removeEventListener('change', this.onChange);
      }
    }

    updateName() {
      if (this.nameEl && this.selectEl) {
        const label = this.selectEl.options[this.selectEl.selectedIndex].textContent;
        this.nameEl.textContent = label;
      }
    }

    setNameFromLocation() {
      if (!this.nameEl) return;

      const h = location.hostname.replace(/^www\./, '').toLowerCase();
      const seg = (location.pathname.toLowerCase().split('/').filter(Boolean)[0]) || '';
      let label = 'English';

      if (h === 'hotwok.com') {
        if (seg === 'de') label = 'Germany';
        else if (seg === 'nl') label = 'Dutch';
        else if (seg === 'fr') label = 'French';
        else if (seg === 'pl-pl') label = 'Polish';
        else label = 'English';
      } else if (h === 'hotwok.es') {
        label = 'Spanish';
      } else if (h === 'hotwok.it') {
        label = 'Italian';
      } else if (h === 'hotwok.fi') {
        label = 'Finnish';
      }

      this.nameEl.textContent = label;
    }

    syncSelectedOption() {
      const s = this.selectEl;
      const h = location.hostname.replace(/^www\./, '').toLowerCase();
      const seg = (location.pathname.toLowerCase().split('/').filter(Boolean)[0]) || '';
      let fallback = 'https://hotwok.com';

      if (h === 'hotwok.com') {
        if (seg === 'de') fallback = 'https://hotwok.com/de';
        else if (seg === 'nl') fallback = 'https://hotwok.com/nl';
        else if (seg === 'fr') fallback = 'https://hotwok.com/fr';
        else if (seg === 'pl-pl') fallback = 'https://hotwok.com/pl-pl';
        else fallback = 'https://hotwok.com';
      } else if (h === 'hotwok.es') {
        fallback = 'https://hotwok.es/';
      } else if (h === 'hotwok.it') {
        fallback = 'https://hotwok.it/';
      } else if (h === 'hotwok.fi') {
        fallback = 'https://hotwok.fi/';
      }

      const norm = (u) => {
        try {
          const x = new URL(u);
          return (
            x.hostname.replace(/^www\./, '').toLowerCase() +
            x.pathname.replace(/\/+$/, '').toLowerCase()
          );
        } catch {
          return String(u)
            .toLowerCase()
            .replace(/^https?:\/\//, '')
            .replace(/^www\./, '')
            .replace(/\/+$/, '');
        }
      };

      const current = norm(location.origin + location.pathname);
      let matched = false;
      for (const o of s.options) {
        if (norm(o.value) === current) {
          s.value = o.value;
          matched = true;
          break;
        }
      }
      if (!matched) s.value = fallback;
    }
  }

  customElements.define('country-selector', CountrySelector);

